/**
 * O texto do `NumeroAnimado` — em módulo próprio porque função exportada de arquivo de componente derruba o lint
 * (`react-refresh/only-export-components`).
 */

/** O formato padrão: inteiro em pt-BR ("1.234"). */
export const inteiro = (n: number) => n.toLocaleString('pt-BR');

/**
 * O texto que o número terá quando acabar de contar. O `KpiCard` escolhe o tamanho da fonte pelo comprimento do
 * que vai escrever; com um elemento no lugar do texto ele media "[object Object]" — e o "R$ 131.804,58" saía
 * cortado em 768 px (medido pelo `scripts/texto-inteiro.mjs`, 06/10/2026).
 */
export function textoFinalDoNumero(props: { valor: number; formatar?: (n: number) => string }): string {
  return (props.formatar ?? inteiro)(props.valor);
}
